import service2 from '@/utils/request2'

/**
 *@Summary 设备列表 - 分页查询
 *
 * @param {*} params
 * @return {*}
 */
export const getDeviceList = params => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/list`,
    method: 'get',
    params
  })
}

/**
 * 1. 请求二维码
 * POST /api/login/qrcode/request
 *
 * @param request 登录请求 (含设备ID和用户ID)
 * @return 登录记录ID和初始状态
 */
export const getLoginQrcodeRequest = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/login/qrcode/request`,
    method: 'POST',
    data
  })
}
/**
 * 2. 查询登录状态
 * GET /api/login/qrcode/status?login_id=xxx
 *
 * @param loginId 登录记录ID
 * @return 当前登录状态 (含验证码图片如需)
 */
export const getLoginQrcodeStatus = params => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/login/qrcode/status`,
    method: 'get',
    params
  })
}

/**
 * 3. 获取二维码图片
 * GET /api/login/qrcode/image?login_id=xxx
 *
 * @param loginId 登录记录ID
 * @return 二维码图片Base64
 */
export const getLoginQrcodeImage = params => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/login/qrcode/image`,
    method: 'get',
    params
  })
}

/**
 * 4. 提交验证码
 * POST /api/login/verify-code/submit
 *
 * @param request 验证码提交请求
 * @return 提交结果和最新状态
 */
// /**
//  * 状态码: 0待执行 1等待扫码 2已扫码 3需验证码 4验证中 5失败 6成功 7已取消 8已过期 9超时
//  */
// private Integer status;

// /**
//  * 前端展示状态: waiting/scanned/need_verify/verifying/success/failed/cancelled/expired/timeout
//  */
// private String displayStatus;

// /**
//  * 验证码图片Base64 (状态为need_verify时返回)
//  */
// private String verifyImageBase64;
export const submitLoginVerifyCode = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/login/verify-code/submit`,
    method: 'post',
    data
  })
}

/**
 * 5. 取消登录
 * POST /api/login/qrcode/cancel
 *
 * @param request 取消请求 (含登录ID)
 * @return 取消结果
 */
export const cancelLoginQrcode = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/login/qrcode/cancel`,
    method: 'post',
    data
  })
}

/**
 * 删除设备
 * DELETE /api/device/{deviceId}
 *
 * @param deviceId 设备ID
 * @return 删除结果
 */
export const deleteDevice = params => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/${params.deviceId}`,
    method: 'DELETE'
  })
}
/**
 * 3. 获取当前绑定设备
 * GET /api/device/bind-status
 *
 * @param loginId 登录记录ID
 * @return 当前绑定设备信息
 */
export const getBindStatus = (params, { timeout } = {}) => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/bind-status`,
    method: 'get',
    params,
    timeout
  })
}

// 重新绑定前主动探测；轮询只查询本次结果，不重复下发命令。
export const startRebindProbe = () => service2({
  url: '/cloud/edata-cloud-phone/admin/api/device/bind-status/rebind-probe',
  method: 'post',
  timeout: 10000
})

export const getRebindProbe = probeId => service2({
  url: `/cloud/edata-cloud-phone/admin/api/device/bind-status/rebind-probe/${probeId}`,
  method: 'get',
  timeout: 10000
})

/**
 * 保存企微掉线通知配置
 * POST /admin/api/device/bind-status
 *
 * @param data 通知配置
 * @return 保存结果
 */
export const saveNotifyConfig = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/bind-status`,
    method: 'POST',
    data
  })
}

/**
 * 3. 获取当前未绑定设备列表
 * GET /api/device/unbound
 *
 * @param loginId 登录记录ID
 * @return 当前未绑定设备列表
 */
export const getUnBindList = params => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/unbound`,
    method: 'get',
    params
  })
}
/**
 * 3. 云手机分配机构
 * GET /api/device/unbound
 *
 * @param loginId 登录记录ID
 * @return 当前未绑定设备列表
 */
export const getAssignOrg = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/assign-org`,
    method: 'POST',
    data
  })
}

/**
 * 获取机构列表
 */
export const getOrganizationList = params => {
  return service2({
    url: `/cloud/edata-user/organization/page`,
    method: 'get',
    params
  })
}

/**
 * 重置设备并重新安装应用（异步任务）
 */
export const resetDevice = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/reset`,
    method: 'post',
    data
  })
}

/**
 * 查询设备最近一次重置任务进度
 */
export const getDeviceResetProgress = deviceId => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/${deviceId}/reset-progress`,
    method: 'get'
  })
}

/**
 * 更新设备代理配置
 */
export const updateDeviceProxy = data => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/device/proxy`,
    method: 'post',
    data
  })
}
